// Module
var code = "<div class=\"fields-sidebar\"></div> <div class=\"editor-content\"> <div class=\"general-errors\"></div> <div id=\"vis-form\"></div> </div> ";
// Exports
export default code;